export type Content = { name: string; link: string };
export const CLASSIFICATION_SEVERITY_MAP = ['no', 'mild', 'moderate', 'severe'];
